import { render, staticRenderFns } from "./userpushreport.vue?vue&type=template&id=a2dd12da&"
import script from "./userpushreport.vue?vue&type=script&lang=js&"
export * from "./userpushreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports